<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active':panel === 'INFOS'}"><a @click="panel = 'INFOS'">Fiche du parking</a></li>
        <li :class="{'is-active':panel === 'DOCS'}">
          <a :class="{'disabled' : isNew}" @click="!isNew ? panel = 'DOCS' : null">Documents</a>
        </li>
      </ul>
    </div>
    <div class="has-bg-brand is-padding-left is-padding-right is-margin-top-xsmall">
      <div class="has-text-white is-size-6 is-padding-top-xsmall is-padding-bottom-xsmall">
        <span class="icon is-small is-size-7"><i class="fas fa-check-circle"></i></span>
        <i>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <div class="has-bg-annonce is-padding-left is-padding-right" v-if="fromFlux">
      <div class="has-text-white is-size-6">
        <span class="icon is-medium is-size-7"><i class="fas fa-rss fa-s"></i></span>
        <i>Ces informations sont automatiquement mises à jour.</i>
      </div>
    </div>
    <form @submit.prevent.stop="submit()">
      <div v-show="panel === 'INFOS'">
        <div class="columns is-multiline has-bg-grey2">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Informations parking<span v-if="!isNew"> {{p.ref}}</span></b>
            </div>
          </div>
          <div class="column is-paddingless is-12 columns is-multiline">
            <div class="column is-6">
              <div class="field">
                <label v-if="!refAvailable" class="label">
                  <span class="icon has-text-primary is-small has-text-danger">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  <span class="">
                    <span>Référence
                      <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
                    </span>
                  </span>
                </label>
                <r-label v-else :label="'Référence'" :value="ref" :from-flux="fromFlux"></r-label>
                <div class="control">
                  <v-input id="ref" name="ref" @input="updateRef" :model="ref"
                          v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Référence">
                  </v-input>
                </div>
                <p v-if="!refAvailable" class="help is-danger" data-type-cy="text" data-value-cy="error">La référence existe déjà</p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless is-12 columns is-multiline">
            <div class="column is-4">
              <r-label :label="'Prix immo HT'" :value="sale_price_ht" :from-flux="fromFlux"></r-label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <v-input id="sale_price_ht" name="sale_price_ht" @input="val => sale_price_ht = val"
                          :model="sale_price_ht" :number="true" input-type="number"
                          v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Prix immo HT">
                  </v-input>
                </div>
                <div class="control">
                  <a class="button is-square is-static is-border is-min-width-0">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div v-if="sale_price_ht && sale_price">
                <label class="label" for="tva">TVA</label>
                <div class="has-text-weight-bold has-text-black is-size-4">
                  {{sale_price_ht | tva(sale_price) | prettyPrice}} %
                </div>
                <div class="has-text-weight-light has-text-black is-size-6">
                  {{sale_price - sale_price_ht | prettyPrice}} {{$currency}}
                </div>
              </div>
            </div>
            <div class="column is-4">
              <r-label :label="'Prix immo TTC'" :value="sale_price" :from-flux="fromFlux"></r-label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <v-input id="sale_price" name="sale_price" @input="val => sale_price = val" :model="sale_price" input-type="number"
                          v-validate="'required|decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number="true"
                          data-vv-as="Prix immo TTC">
                  </v-input>
                </div>
                <div class="control">
                  <a class="button is-square is-static is-border is-min-width-0">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showStatusSelect && !hasCheck" class="columns is-multiline">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-12 is-padding-left is-padding-right is-padding-top">
              <label class="label" for="tags">Statut d'édition du parking</label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-3 has-bg-white" v-for="s in availableLotStatusList" :key="'status-'+s.value">
                  <input v-model="parkingStatus" :value="s.value" :disabled="!isAdmin"
                        :name="'statusLot'" :id="'status-'+s.value" type="radio" class="checkradiocase is-fullwidth">
                  <label :for="'status-'+s.value">{{s.label}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="panel === 'DOCS'">
        <div class="columns is-multiline has-bg-light">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Plan du lot</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column columns is-multiline is-paddingless-left is-paddingless-bottom">
            <div class="column is-12">
              <div v-if="!fromFlux">
                <upload-file @upload="uploadPlan"
                             :documents="compact([plan])"
                             :unique="true"
                             :canDrag="false"></upload-file>
              </div>
            <div v-else>
              <view-file-list :documents="compact([plan])" :fromFlux="true" v-if="plan"></view-file-list>
              <div v-else>Le promoteur ne fournit pas de plan pour ce lot.</div>
            </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Documents</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column is-12">
            <div>
              <label class="label">Téléchargez des documents</label>
              <upload-file @upload="uploadDocument"
                           :placeholder="'Sélectionner document(s)'"
                           :documents="documents"></upload-file>
            </div>
          </div>
        </div>
        <div class="columns is-multiline has-bg-light" v-if="program && program.from_flux">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Documents issus du flux promoteur</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column is-12">
            <div v-if="documentsFlux && documentsFlux.length">
              <view-file-list :documents="documentsFlux" :fromFlux="true"></view-file-list>
            </div>
            <div v-else>
              <div>Le promoteur ne fournit pas de document.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="formActionsSticky is-bottom is-margin-top">
        <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <a @click="$router.goBack(route)" class="button is-light is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-left-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                  :disabled="!canSubmit || loading" @click="submit"
                  :class="{'is-loading':loading}">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { debounce, compact, isEmpty } from 'lodash'
  import { DefaultValues } from '../../mixins'

  const emptyParking = {
    ref: null,
    lot_type: null,
    status: 'draft',
    sale_price: null,
    sale_price_ht: null,
    profitability: null,
    floor: null
  }

  export default {
    name: 'ParkingForm',
    props: {
      edit: {
        type: Boolean,
        default: false
      },
      source: {
        required: false
      },
      program: {
        required: true
      },
      loading: {
        required: false
      }
    },
    data () {
      return {
        hasCheck: false,
        parking: {},
        refAvailable: true,
        rent: null,
        documents: [],
        ref: null,
        sale_price: null,
        sale_price_ht: null,
        profitability: null,
        route: this.$route,
        isNew: true,
        panel: 'INFOS',
        plan: null,
        compact
      }
    },
    mixins: [DefaultValues],
    computed: {
      ...mapGetters(['isExternal', 'isAdmin', 'isManager']),
      showStatusSelect () {
        if (!this.source) return
        if ('status' in this.source) {
          return ['draft', 'available'].includes(this.source.status)
        }
      },
      availableLotStatus () {
        return [
          this.statusData.draft,
          this.statusData.available
        ]
      },
      availableLotStatusList () {
        return Object.values(this.availableLotStatus)
      },
      p () {
        return this.parking
      },
      canSubmit () {
        return this.refAvailable && this.ref !== null && this.ref !== '' &&
        this.sale_price !== null && this.sale_price !== '' && this.sale_price_ht !== null &&
        this.sale_price_ht !== ''
      },
      fromFlux () {
        if (this.program && this.program.from_flux) {
          return this.program.from_flux
        } else return false
      },
      documentsFlux () {
        if (this.lot && this.lot.documents_flux && this.lot.documents_flux.length > 0) {
          return this.lot.documents_flux
        } else return []
      }
    },
    watch: {
      rent () {
        this.setProfitability()
      },
      sale_price () {
        this.setProfitability()
      }
    },
    methods: {
      submit () {
        this.validate((valid) => {
          if (valid) {
            if (this.loading) return
            this.parking.rent = this.rent
            this.parking.sale_price = this.sale_price
            this.parking.sale_price_ht = this.sale_price_ht
            this.parking.ref = this.ref
            this.parking.documents = this.documents
            this.parking.profitability = this.profitability
            this.parking.status = this.parkingStatus
            this.parking.nature = 'parking'
            this.parking.program = this.program.pk
            if (this.plan && !isEmpty(this.plan)) {
              this.parking.plan = [this.plan]
            } else this.parking.plan = null
            this.$emit('submit', this.parking)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Le formulaire est invalide.'
            })
          }
        })
      },
      updateRef: debounce(function (val) {
        let previousVal = this.ref
        this.ref = val
        if (this.ref !== previousVal && val.length >= 2) {
          this.$api.lotService.get({ref: val, program: this.program.pk}).then(r => {
            if ((r.data.items.length === 1 && r.data.items[0].pk === this.parking.pk) || r.data.items.length === 0) {
              this.refAvailable = true
            } else {
              this.refAvailable = false
              this.$notify({
                type: 'is-danger',
                text: 'La référence existe déjà.'
              })
            }
          })
        }
      }, 700),
      uploadDocument (e) {
        if (e.cropped) this.documents.splice(e.croppedIndex, 1, e[0])
        else e.map(el => this.documents.push(el))

        this.$set(this.parking, 'documents', this.documents)
      },
      uploadPlan (e) {
        if (e && e.length) {
          this.$set(this, 'plan', e[0])
        } else {
          this.$set(this, 'plan', null)
        }
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      checkRef (parkingRef) {
        this.$api.lotService.get({ref: parkingRef, program: this.program.pk})
      },
      setProfitability () {
        if (!this.p.profitability && this.rent && this.sale_price) {
          this.profitability = (((this.rent * 12) / this.sale_price) * 100).toFixed(2)
        } else {
          this.profitability = this.p.profitability
        }
      }
    },
    created () {
      this.parking.program = this.program
      if (this.source) {
        this.isNew = false
        this.parking = Object.assign(this.parking, this.source)
        if (!this.edit) {
          this.parking.ref = null
          this.parking.pk = null
          this.parkingStatus = 'draft'
          this.parking.documents = []
          this.parking.plan = []
        } else {
          this.parkingStatus = this.source.status
          this.documents = this.source.documents
          if (this.parking.plan) {
            this.plan = this.parking.plan
          }
        }
        this.rent = this.parking.rent
        this.ref = this.parking.ref
        this.sale_price = this.parking.sale_price
        this.sale_price_ht = this.parking.sale_price_ht
        this.profitability = this.parking.profitability
      } else {
        this.parking = Object.assign(this.parking, emptyParking)
        this.parkingStatus = 'draft'
        this.plan = null
        this.documents = []
      }
      if ('check' in this.$route.query) {
        this.hasCheck = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/parking/ParkingForm.vue